import { createContext, useContext } from 'react';
import type { RuntimeConfig } from './config.js';

export const ConfigContext = createContext<RuntimeConfig | null>(null);

export function useRuntimeConfig(): RuntimeConfig {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error('RuntimeConfig is not available');
  }
  return config;
}
